export default {
    computed: {
        rulesEmail() {
            return [
                value => {
                    if (/.+@.+\..+/.test(value)) return true

                    return 'Адрес эл. почты должен\nбыть действительным.'
                },
            ]
        },
        rulesRequired() {
            return [
                value => {
                    if (value) return true

                    return 'Это поле является\nобязательным!'
                }
            ]
        },
        rulesPassword() {
            return [
                value => {
                    if (value) return true

                    return "Это поле является\nобязательным!"
                },
                value => {
                    const condition1 = value.length >= 15;
                    const condition2 = value.length >= 8 && /[a-zA-Z]/.test(value) && /\d/.test(value);
                    if(condition1 || condition2) return true
                    return "Выполните условие!"
                },
            ]
        }
    },
    methods: {
        rulesSizeNumber(maxNumber) {
            return [
                value => {
                    if (value) return true

                    return "Это поле является\nобязательным!"
                },
                value => {
                    if (value <= maxNumber) return true
                    return "Недостаточно средств!"
                },
            ]
        },
    }
}